import { MousePosition } from 'ol/control'
import { toStringHDMS } from 'ol/coordinate'

export function createMousePosition() {
  return new MousePosition({
    coordinateFormat: function (coord) {
      return toStringHDMS(coord, 1)
    },
    // ol.coordinate.createStringXY(4),
    projection: 'EPSG:4326',
    placeholder: '##° ##′ ##.#″ # ##° ##′ ##.#″ #',
  })
}
